import React, { useRef } from 'react'
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline'

const SCROLL_STEP = 320

const NAV_BTN_CLASS =
  'inline-flex h-8 w-8 items-center justify-center rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700'

type HorizontalTableScrollProps = {
  children: React.ReactNode
  showNavButtons?: boolean
}

/** Botões de rolagem horizontal no padrão das listas (ex.: Usuários). */
export const HorizontalTableScroll: React.FC<HorizontalTableScrollProps> = ({
  children,
  showNavButtons = true,
}) => {
  const scrollRef = useRef<HTMLDivElement>(null)

  const scrollBy = (dx: number) => {
    scrollRef.current?.scrollBy({ left: dx, behavior: 'smooth' })
  }

  const handleWheel = (event: React.WheelEvent<HTMLDivElement>) => {
    if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return
    event.preventDefault()
    scrollRef.current?.scrollBy({ left: event.deltaY, behavior: 'auto' })
  }

  return (
    <>
      {showNavButtons && (
        <div className="mb-2 flex items-center justify-end gap-2 px-3 pt-4">
          <button
            type="button"
            onClick={() => scrollBy(-SCROLL_STEP)}
            className={NAV_BTN_CLASS}
            aria-label="Rolar para a esquerda"
          >
            <ChevronLeftIcon className="h-4 w-4" />
          </button>
          <button
            type="button"
            onClick={() => scrollBy(SCROLL_STEP)}
            className={NAV_BTN_CLASS}
            aria-label="Rolar para a direita"
          >
            <ChevronRightIcon className="h-4 w-4" />
          </button>
        </div>
      )}
      <div
        ref={scrollRef}
        className="w-full max-w-full overflow-x-auto"
        onWheel={handleWheel}
      >
        {children}
      </div>
    </>
  )
}
